import { useState, useEffect } from "react";
import AddButton from "./ui-icons/buttons/AddButton";
import Trash from "./ui-icons/buttons/Trash";
import Revision from "./ui-icons/buttons/Revision";
import Сancel from "./ui-icons/buttons/Сancel";
import Approve from "./ui-icons/buttons/Approve";
import { classNames } from "../helpers/classNames";
import ReturnToWork from "./ui-icons/buttons/ReturnToWork";
import Copy from "./ui-icons/buttons/Copy";
import { DownloadIcon } from "./ui-icons/upload";
import { Pencil } from "./ui-icons/card";
import QuestionIcon from "./ui-icons/buttons/Question";
import SettingsIcon from "./ui-icons/buttons/Settings";
import AuditIcon from "./ui-icons/buttons/AuditIcon";
import IncidentIcon from "./ui-icons/buttons/IncidentIcon";
import SecurityIcon from "./ui-icons/buttons/SecurityIcon";

type Props = {
  open?: boolean;
  setOpen?: (b: boolean) => void;
  classBg: string;
  text: string;
  icon?: boolean;
  shadow?: boolean;
  setCloseAllModals?: (b: boolean) => void;
  closeAllModals?: boolean;
  step?: number;
  typeIcon?: string;
  setStep?: (n: number) => void;
  customFunction?: (params: any) => void;
  paramsCustomFunction?: any;
  disabled?: boolean;
  submit?: boolean;
  dataAttribute?: string;
  form?: string;
  style?: any;
  iconEnd?: boolean
};

const SupplayButton = (props: Props) => {
  const {
    open,
    setOpen,
    classBg,
    text,
    icon,
    shadow,
    setCloseAllModals,
    closeAllModals,
    step,
    setStep,
    customFunction,
    paramsCustomFunction,
    typeIcon,
    disabled,
    submit,
    dataAttribute,
    form,
    style,
    iconEnd
  } = props;
  return (
    <button
      style={style}
      form={form}
      data-reject={dataAttribute === "reject" && true}
      data-archive={dataAttribute === "archive" && true}
      data-approve={dataAttribute === "approve" && true}
      data-modification={dataAttribute === "modification" && true}
      data-agreement={dataAttribute === "agreement" && true}
      data-revision={dataAttribute === "revision" && true}
      data-draft={dataAttribute === "draft" && true}
      data-add5way={dataAttribute === "add5way" && true}
      data-addinc={dataAttribute === "addinc" && true}
      disabled={disabled}
      onClick={(e) => {
        if (!submit) {
          e.preventDefault();
        }
        customFunction && customFunction(paramsCustomFunction);
        setOpen && setOpen(!open);
        setCloseAllModals && setCloseAllModals(!closeAllModals);
        if (step) {
          setStep && setStep(step + 1);
        }
      }}
      className={classNames(
        `gap-2 flex items-center py-3 px-6 rounded-md leading-[22px] disabled:bg-[#E5E7EB] disabled:text-[#374151] disabled:cursor-not-allowed`,
        `${classBg}`,
        shadow ? "shadow-custom" : ""
      )}
    >
      {icon && (
        <>
          {typeIcon === "remove" && <Trash />}
          {typeIcon === "add" && <AddButton />}
          {typeIcon === "revision" && <Revision />}
          {typeIcon === "cancel" && <Сancel />}
          {typeIcon === "approve" && <Approve />}
          {typeIcon === "return" && <ReturnToWork />}
          {typeIcon === "copy" && <Copy />}
          {typeIcon === "download" && <DownloadIcon />}
          {typeIcon === "pencil" && <Pencil />}
          {typeIcon === "question" && <QuestionIcon />}
          {typeIcon === "settings" && <SettingsIcon />}
          {typeIcon === "audit" && <AuditIcon />}
          {typeIcon === "incident" && <IncidentIcon />}
          {typeIcon === "security" && <SecurityIcon />}
        </>
      )}
      <span className="w-full text-center sm:text-left">{text}</span>

      {iconEnd && (
        <>
          {typeIcon === "remove" && <Trash />}
          {typeIcon === "add" && <AddButton />}
          {typeIcon === "revision" && <Revision />}
          {typeIcon === "cancel" && <Сancel />}
          {typeIcon === "approve" && <Approve />}
          {typeIcon === "return" && <ReturnToWork />}
          {typeIcon === "copy" && <Copy />}
          {typeIcon === "download" && <DownloadIcon />}
          {typeIcon === "pencil" && <Pencil />}
          {typeIcon === "question" && <QuestionIcon />}
          {typeIcon === "settings" && <SettingsIcon />}
          {typeIcon === "audit" && <AuditIcon />}
          {typeIcon === "incident" && <IncidentIcon />}
          {typeIcon === "security" && <SecurityIcon />}
        </>
      )}
    </button>
  );
};

export default SupplayButton;
